if (!customElements.get('sg-card-rail')) {
  customElements.define('sg-card-rail', class extends HTMLElement {
    connectedCallback() {
      this.frame = 0;
      this.controller = new AbortController();
      const init = () => {
        if (!this.isConnected || this.viewport) return;
        const viewport = this.querySelector('.sg-card-viewport');
        const group = viewport?.querySelector('.sg-card-group');
        if (!group?.children.length) return;
        this.viewport = viewport;
        this.group = group;
        for (let i = 0; i < 2; i++) {
          const clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
          viewport.append(clone);
        }
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        const pause = this.querySelector('[data-pause]');
        const label = () => { if (!pause) return; pause.textContent = this.paused ? 'Riprendi' : 'Pausa'; pause.setAttribute('aria-pressed', String(this.paused)); };
        const on = (el, event, fn, options = {}) => el?.addEventListener(event, fn, {...options, signal: this.controller.signal});
        label();
        on(pause, 'click', () => { this.paused = !this.paused; label(); });
        on(this.reduced, 'change', () => { this.paused = this.reduced.matches; label(); });
        const delay = () => { this.resumeAt = performance.now() + 4000; this.position = viewport.scrollLeft; };
        on(viewport, 'pointerdown', e => { this.dragging = true; this.startX = e.clientX; this.startScroll = viewport.scrollLeft; this.pointerType = e.pointerType; delay(); if(e.pointerType === 'mouse') viewport.setPointerCapture(e.pointerId); });
        on(viewport, 'pointermove', e => { if(this.dragging && this.pointerType === 'mouse') { viewport.scrollLeft = this.startScroll - (e.clientX - this.startX); delay(); } });
        const release = () => { this.dragging = false; delay(); };
        on(window, 'pointerup', release); on(window, 'pointercancel', release);
        on(viewport, 'wheel', delay, {passive:true});
        on(viewport, 'scroll', () => { if(this.dragging || performance.now() < (this.resumeAt || 0)) this.position = viewport.scrollLeft; }, {passive:true});
        on(viewport, 'focusin', () => { this.focused = viewport.matches(':focus-visible'); });
        on(viewport, 'focusout', () => { this.focused = false; delay(); });
        on(viewport, 'keydown', e => { if(e.code === 'Space') { e.preventDefault(); this.paused = !this.paused; label(); } if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); viewport.scrollLeft += (e.key === 'ArrowRight' ? 1 : -1) * 180; delay(); } });
        for (const [selector, sign] of [['[data-prev]',-1],['[data-next]',1]]) on(this.querySelector(selector), 'click', () => { viewport.scrollLeft += sign * 230; delay(); });
        this.resize = new ResizeObserver(() => {
          this.width = group.getBoundingClientRect().width;
          this.position = this.width;
          viewport.scrollLeft = this.position;
        });
        this.resize.observe(group);
        this.visible = false;
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        const tick = now => {
          const dt = Math.min((now - (this.last || now)) / 1000, .05); this.last = now;
          if(this.width && !this.dragging && now >= (this.resumeAt || 0)) {
            if(!this.paused && this.visible && !this.focused && !document.hidden) this.position -= (Number(this.dataset.speed) || 12) * dt;
            if(this.position < this.width * .5) this.position += this.width;
            if(this.position > this.width * 1.5) this.position -= this.width;
            viewport.scrollLeft = this.position;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      };
      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true, signal:this.controller.signal});
      else init();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.controller?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      if(this.viewport) Array.from(this.viewport.children).slice(1).forEach(el=>el.remove());
      this.viewport = null;
    }
  });
}
